// extracted by mini-css-extract-plugin
module.exports = {"floatButton":"FloatButton_floatButton__19o4O","button":"FloatButton_button__2X4df","icon":"FloatButton_icon__3u2hZ"};